import React from 'react';
import './ListHighlighted.css';

const ListHighlighted = ({list}) => {
    return (
        <ul className="ListHighlighted">
            {
                list.map((item, index) => (
                    <li
                        key={index}
                        dangerouslySetInnerHTML={{__html: item.replace(/&nbsp;/g, ' ')}}
                    ></li>
                ))
            }
        </ul>
    );
};

export default ListHighlighted;
